import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as fnbActions from './../../../../../../actions/fnbAction';
import ProductDetail from './ProductDetail';
import { uploadAction } from "actions/uploadAction";

const mapStateToProps = state => {
    return {
        fnbState: state.fnbReducer,
        uploadState: state.uploadReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProductDetail: (id) => dispatch(fnbActions.getProductDetail(id)),
        updateProduct: (payload) => dispatch(fnbActions.updateProduct(payload)),
        syncProducts: () => dispatch(fnbActions.syncProducts()),
        translateProduct: (payload) => dispatch(fnbActions.translateProduct(payload)),
        deleteProductTranslateById: (payload) => dispatch(fnbActions.deleteProductTranslateById(payload)),
        onUploadFile: (filters) => dispatch(uploadAction(filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ProductDetail));
